<div class="add-customer-contact">
  <mat-card class="curtains">
    <div class="customer-contact-header secondary-icon">
      <h5>Customer Contact</h5>
      <div class="customer-panel">
        <button matIconButton (click)="confirmDeleteCustomerContact()">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </div>
    <mat-card-content>
      <form [formGroup]="customerContactedForm">
        <div class="three-fields">
          <mat-form-field>
            <mat-label>From</mat-label>
            <mat-select formControlName="contactFrom" required>
              @for (from of contactsFrom; track from) {
                <mat-option [value]="from.type">
                  {{ from.displayName }}<span>{{ from.type === 'OWNER' ? ' (Owner)' : '' }}</span>
                </mat-option>
              }
            </mat-select>
            @if (contactFrom.invalid) {
              <mat-error>From is <strong>required</strong></mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>To</mat-label>
            <mat-select formControlName="contactTo" required>
              @for (to of contactsTo; track to) {
                <mat-option [value]="to.type">
                  {{ to.displayName }}<span>{{ to.type === 'OWNER' ? ' (Owner)' : '' }}</span>
                </mat-option>
              }
            </mat-select>
            @if (contactTo.invalid) {
              <mat-error>To is <strong>required</strong></mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>Contact method</mat-label>
            <mat-select formControlName="contactMethodType" required>
              @for (contactMethod of customerContactMethodEnum | keyvalue; track contactMethod) {
                <mat-option [value]="contactMethod.key">
                  <span>{{ contactMethod.value }}</span>
                </mat-option>
              }
            </mat-select>
            @if (contactMethodType.invalid) {
              <mat-error>Contact method is <strong>required</strong></mat-error>
            }
          </mat-form-field>
        </div>
        <div class="five-fields">
          <mat-form-field>
            <mat-label>Date</mat-label>
            <input
              [matDatepicker]="customerContactDatepicker"
              [max]="currentDate"
              formControlName="date"
              (dateChange)="validateTime()"
              matInput
              required />
            <mat-datepicker-toggle [for]="customerContactDatepicker" matSuffix></mat-datepicker-toggle>
            <mat-datepicker #customerContactDatepicker></mat-datepicker>
            <mat-hint>DD/MM/YYYY</mat-hint>
            @if (date.errors?.matDatepickerParse && !date.errors?.matDatepickerMax) {
              <mat-error> Format is <strong>DD/MM/YYYY</strong> </mat-error>
            }
            @if (date.errors?.required && !date.errors?.matDatepickerParse && !date.errors?.matDatepickerMax) {
              <mat-error> Date is <strong>required</strong> </mat-error>
            }
            @if (date.errors?.inFuture) {
              <mat-error> Date cannot be in the future </mat-error>
            }
          </mat-form-field>

          <mat-form-field class="time-picker">
            <mat-label>Time</mat-label>
            <input type="text" formControlName="time" (input)="validateTime()" matInput required />
            <mat-hint>HH:mm</mat-hint>
            @if (time.errors?.required && !time.errors?.invalid && !time.errors?.inFuture) {
              <mat-error> The time is <strong>required</strong> </mat-error>
            }
            @if (time.errors?.invalid && !time.errors?.inFuture) {
              <mat-error> The time format is <strong>HH:mm</strong> </mat-error>
            }
            @if (time.errors?.inFuture) {
              <mat-error> Time cannot be in the future </mat-error>
            }
          </mat-form-field>

          <div class="contact-successful">
            <label id="radio-group-contact-successful" class="body-2">Contact successful</label>
            <mat-radio-group
              aria-labelledby="radio-group-contact-successful"
              formControlName="isContactSuccessful"
              class="radio-group charcoal-radio">
              <mat-radio-button class="body-1" [value]="true">Yes</mat-radio-button>
              <mat-radio-button class="body-1 no" [value]="false">No</mat-radio-button>
            </mat-radio-group>
          </div>

          @if (isContactSuccessful.value) {
            <div class="issue-discussed">
              <label id="radio-group-issue discussed" class="body-2">Was an issue discussed</label>
              <mat-radio-group
                aria-labelledby="radio-group-issue discussed"
                formControlName="isIssueDiscussed"
                class="radio-group charcoal-radio">
                <mat-radio-button class="body-1" [value]="true">Yes</mat-radio-button>
                <mat-radio-button class="body-1 no" [value]="false">No</mat-radio-button>
              </mat-radio-group>
            </div>
          }

          @if (isIssueDiscussed.value) {
            @if (isIssueDiscussed.value) {
              <mat-form-field>
                <mat-label>Issue resolution</mat-label>
                <mat-select formControlName="issueResolutionType" [required]="isIssueDiscussed.value">
                  @for (resolution of issueResolutionEnum | keyvalue; track resolution) {
                    <mat-option [value]="resolution.key">
                      {{ resolution.value }}
                    </mat-option>
                  }
                </mat-select>
                @if (issueResolutionType.invalid) {
                  <mat-error>Issue resolution is <strong>required</strong></mat-error>
                }
              </mat-form-field>
            }
          }
        </div>

        @if (isIssueDiscussed.value) {
          <mat-form-field>
            <mat-label>Issue discussed</mat-label>
            <textarea
              matInput
              autocomplete="off"
              formControlName="issueDiscussionDetails"
              maxlength="65535"
              cdkTextareaAutosize="true"
              cdkAutosizeMinRows="1"
              required></textarea>
            @if (issueDiscussionDetails.invalid) {
              <mat-error>Issue details is <strong>required</strong></mat-error>
            }
          </mat-form-field>
        }

        <mat-form-field>
          <mat-label>Additional details</mat-label>
          <textarea
            matInput
            autocomplete="off"
            formControlName="additionalDetails"
            maxlength="65535"
            cdkTextareaAutosize="true"
            cdkAutosizeMinRows="1"
            required></textarea>
          @if (additionalDetails.invalid) {
            <mat-error>Additional details is <strong>required</strong></mat-error>
          }
        </mat-form-field>
      </form>
    </mat-card-content>
  </mat-card>
</div>
